import configVars from "@/config/config_vars";
let appBaseUrl = configVars.appBaseUrl;

import axios from "axios";

import querystring from "querystring";




var searchesSuggestions = (search) => {
  return new Promise((resolve, reject) => {
    //http://localhost:3069/tevo/searches/suggestions?entities=events,performers,venues&limit=5&q=yankee
    let searchesSuggestionsByQ = `${appBaseUrl}tevo/searches/suggestions?entities=events,performers,venues&q=${search}`;
    let instance = axios.create();
    instance.defaults.headers.common = {};
    instance
      .get(`${searchesSuggestionsByQ}`)
      .then(response => {
        resolve(response.data.suggestions);
      })
      .catch(error => {
       
      });
  });
}


export default {
  searchesSuggestions
}
